import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  if (response?.data && response?.data?.length > 0) {
    return response
  } else {
    throw {
      message: 'No data found',
    }
  }
}

const getPincodeData = (pincode: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getPincodeData,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: { key: 'pincode', value: pincode },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getPincodeData }
